// Harleigh - More custom functions

// Main DOMContentLoaded Event Listener
document.addEventListener('DOMContentLoaded', function () {
   console.log('Test Fired - 11/24/24 10:31pm v13');
    console.log('Script loaded');

    // Call functions for individual tasks
    handleUnavailableProducts();
    setupVideoAutoplay();
    stopFlickityAutoplay();
});

// Function to handle unavailable products
function handleUnavailableProducts() {
    console.log('Handling unavailable products');

    // Define unavailable products by their variant IDs and product page URLs
    const unavailableProducts = {
        '44028106768550': '/products/calm-serum', // CALM Serum
        //'45369836273830': '/products/eye-serum' // EYE Serum
    };

    // Select all buttons with the 'custom-add-to-cart-btn' class
    const addToCartButtons = document.querySelectorAll('button.custom-add-to-cart-btn[data-variant-id]');
    console.log('Found add-to-cart buttons:', addToCartButtons);

    // Iterate over each button
    addToCartButtons.forEach(function (button) {
        const variantId = button.getAttribute('data-variant-id');
        console.log('Checking button for variant ID:', variantId);

        // If the variant is unavailable
        if (unavailableProducts[variantId]) {
            console.log(`Disabling add-to-cart for unavailable variant ID: ${variantId}`);

            // Change button text to "LEARN MORE"
            button.textContent = 'LEARN MORE';

            // Redirect to the product page when clicked
            button.onclick = function (event) {
                event.preventDefault(); // Prevent default behavior - contributing to bug
                window.location.href = unavailableProducts[variantId];
            };

            // Remove any attributes related to add-to-cart functionality
            button.removeAttribute('data-variant-id');
            button.classList.add('learn-more-btn'); // Optional styling for clarity
        }
    });
}

// Function to set up video autoplay
function setupVideoAutoplay() {
    console.log('Setting up video autoplay');
    const video = document.querySelector('video');
    if (video) {
        video.muted = true; // Ensure the video is muted
        video.play().catch(error => console.error('Autoplay failed:', error));
    }
}

// Function to stop Flickity autoplay
function stopFlickityAutoplay() {
    console.log('Stopping Flickity autoplay');

    // Find all Flickity sliders on the page
    const sliders = document.querySelectorAll('.flickity-enabled');

    sliders.forEach(function (slider) {
        const flickityInstance = Flickity.data(slider);

        if (flickityInstance) {
            // If the page is a product page or matches the specific slider ID, stop it
            if (
                document.body.classList.contains('template-product') || 
                slider.id === 'shopify-section-template--17585652957350__custom_switcher_YYj8qb'
            ) {
                flickityInstance.stopPlayer();
            }
        }
    });
}


// DOM Mutation observer
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        console.log('Mutation detected:', mutation);
    });
});